import ProcessActionRoutes from '../constants/process_action_routes';
import ProcessLayoutStates from '../constants/process_layout_states';
import { ActivityFormEventHandler, ActivityFormEvents } from '../events/activity_form_event_handler';
import ActivityFormEventsProxy from '../events/activity_form_events_proxy';
import LoadProcessInstanceDataActionHandler from '../handlers/load_process_instance_data_action_handler';
import SaveActivityActionHandler from '../handlers/save_activity_action_handler';
import ActivityFormResponseHandler from '../handlers/activity_form_response_handler';
import BlockedActivityInstanceHandler from '../handlers/blocked_activity_instance_handler';
import ProcessStoreItem from '../models/process_store_item.js';

import PostMessageEventHandler from "../../post_message/post_message_event_handler";

import { printForm } from 'utils/print_form.js';
import { getParamUrl } from '../../utils/query_string_parser';


import { FormEventHandler, FormEvents } from 'form/events/form_event_handler';
import { FormActions } from 'form/reflux/form_store';
import { ModalActions } from 'realize_overrides/stores/modal_store';
import RestClient from 'rest_client/rest_client';
import ResponseHandler from 'rest_client/response_handler';
import ScreenSizes from 'screen_sizes';
import { parseFromObject } from 'utils/query_string_parser';
import FileDownloaderUtils from 'utils/file_downloader_utils';
import { serializePrivateProperties } from 'utils/object_utils';

import { FormAPI } from 'lecom-api';

import LecomRefluxActons from '../../reflux/lecom_reflux_actions';
import BaseReflux from '../../reflux/base_reflux.js';

import ActivityStatuses from "../constants/activity_statuses";

export const ProcessActions = Reflux.createActions([
	'loadProcessInstanceData',
	'displayFormResultMessages',
	'saveActivity',
	'openProcessHelpModal',
	'markActivityAsUnread',
	'markActivityAsRead',
	'downloadProcessHelpFile',
	'openAssignActivityToUserModal',
	'assignActivityToUser',
	'openTimeLine',
	'printForm',
	// 'setHighContrast'
].concat(LecomRefluxActons));

export const ProcessStore = Reflux.createStore(Object.assign(BaseReflux, {
	listenables: ProcessActions,
	eventHandler: ActivityFormEventHandler,
	events: ActivityFormEvents,
	store: {},

	modals: {
		processHelpModalId: 'help-modal',
		assignActivityToUserModalId: 'assign-activity-to-user-modal'
	},

	onInit(props) {
		let itemId = props.id;

		this.store[itemId] = Object.assign(props, {
			formStoreId: `form-${props.processIds.processInstanceId}-${props.processIds.activityInstanceId}-${props.processIds.cycle}`
		});

		this.eventHandler.publish(ActivityFormEvents.LOAD_PROCESS_STORE_PROPS);
		this._initResizeEventListener(itemId);
		this._subscribeToFormActionEvents(itemId);
		this._loadProcessInstanceData(itemId, props.processIds);
		this._loadFormDefinition(itemId);
		this._loadInitialValues(itemId);
		this._setHighContrast(itemId);
		this._subscribeSetHighContrast(itemId);
	},

	/* Form submit actions event listeners */

	_subscribeToFormActionEvents(itemId) {
		FormEventHandler.subscribe(FormEvents.SUBMIT_SUCCESS, this._handleFormSubmissionSuccessfulEvent.bind(this, itemId));
	},

	_handleFormSubmissionSuccessfulEvent(itemId, eventName, formStoreId, actionId, response, request) {
		const storeItem = this._getStoreItem(itemId);
		if(formStoreId !== storeItem.formStoreId) return;
		ActivityFormResponseHandler.execute(storeItem, response, request);
	},

	/* ProcessStore action handlers */

	onLoadProcessInstanceData(itemId, processIds) {
		// const processIdsToLoad = processIds || this.store[itemId].processIds;
		// this.trigger({
		// 	id: itemId,
		// 	processIds: processIdsToLoad,
		// 	displayFormHeader: true
		// }, () => {
			this._loadProcessInstanceData(itemId, processIds);
		// })

		this._publish(this.events.LOAD_PROCESS_INSTANCE_DATA, ...arguments);
	},

	onDisplayFormResultMessages(itemId, messages) {
		this.trigger({
			id: itemId,
			displayFormResult: true,
			formResultMessages: messages,
		}, this._publish.bind(this, this.events.DISPLAY_FORM_RESULT_MESSAGES, itemId));
	},

	onSaveActivity(itemId) {
		const storeItem = this._getStoreItem(itemId);
		const formAPI = FormAPI.form(storeItem.formStoreId);

		this.trigger({
			id: itemId,
			waitingForAction: true
		}, () => {
			SaveActivityActionHandler.execute(storeItem)
				.then((response) => {
					this.trigger({
						id: itemId,
						waitingForAction: false
					});

					this._publish(this.events.ACTIVITY_FORM_SAVE_SUCCESS, response).then(formAPI.publish(FormEvents.SAVE_FORM_SUCCESS));
				})
				.catch(() => {
					this.trigger({
						id: itemId,
						waitingForAction: false
					});

					this._publish(this.events.ACTIVITY_FORM_SAVE_ERROR).then(formAPI.publish(FormEvents.SAVE_FORM_ERROR));

					$('.saveActivity').focus();
				});
		});

		this._publish(this.events.ACTIVITY_FORM_SAVE, ...arguments);

	},

	onOpenProcessHelpModal(itemId) {
		ModalActions.open({ modalId: this.modals.processHelpModalId });
	},

	onDownloadProcessHelpFile(itemId, processIds={}, processDefinitionIds={}) {
		const url = ProcessActionRoutes.DOWNLOAD_HELP_FILE;
		FileDownloaderUtils.download(url, processDefinitionIds);
	},

	onMarkActivityAsUnread(itemId) {
		this.performMarkActivityAsReadRequest(itemId, false);
	},

	onMarkActivityAsRead(itemId) {
		this.performMarkActivityAsReadRequest(itemId, true);
	},

	onAssignActivityToUser(itemId, processIds={}, userId) {
		const url = ProcessActionRoutes.ASSIGN_ACTIVITY_TO_USER;
		const params = this.buildAssignActivityToUserRequestParams(processIds, userId);
		RestClient.post(url, params).then(
			this.handleAssignActivityToUserDataSuccess.bind(this, itemId),
			ResponseHandler.displayErrorResponseFlashMessage.bind(this, 'flash-form')
		);

		const modalId = this.modals.assignActivityToUserModalId;
		ModalActions.close({ modalId });
		ActivityFormEventHandler.publish(ActivityFormEvents.ACTIVITY_ASSIGN_ACTIVITY_TO_USER, params);
	},

	onOpenAssignActivityToUserModal(itemId) {
		const modalId = this.modals.assignActivityToUserModalId;

		setTimeout(() => {
			let modasIsVisible = $('#assign-activity-to-user-modal').is(':visible');
			if(modasIsVisible === true){
				let selectWeapper = $('.autocomplete-modal-redirect .select-wrapper ');
				let fieldAutocomplete = $('#autocomplete_select_undefined');
				let btnFechar = $('.Fechar');
				let btnOpenAssignActivity = $('.openAssignActivityToUserModal')

				if(selectWeapper)
					fieldAutocomplete.focus();

				btnFechar.keydown(function(e) {
					if(!e.shiftKey && e.which === 9){
						let inputAutocomplete = $('#assign-activity-to-user-modal .autocomplete-modal-redirect .select-wrapper input');
						inputAutocomplete.focus();
						return false
					}
				});

				btnFechar.on('click', () => {
					btnOpenAssignActivity.focus();
				});

				$('#assign-activity-to-user-modal').keydown((e) => {
					if(e.which === 27)
						btnFechar.click();
				})

			}
		}, 800)

		ModalActions.open({ modalId }, ResponseHandler.displaySuccessFlashMessage.bind(this,
			Realize.i18n.t(`activity.assignToUserModal.selectUser`),
			"flash-modal"),
		);
	},

	onOpenTimeLine(itemId) {
		window.parent.postMessage({
			event: 'openTimeLine',
			dados: this.store[itemId].processIds
		}, '*');
	},

	onPrintForm(itemId, processIds) {
		const storeItem = this.store[itemId];
		const processIdsToLoad = processIds || this.store[itemId].processIds;
		printForm(storeItem.formStoreId, processIdsToLoad.processInstanceData);
	},

	/* private methods */
	_setHighContrast(itemId, eventName, response){
		let valueHighContrast = false;

		if (response && response.data && response.data.highContrast !== undefined && response.data.highContrast !== null) {
			valueHighContrast = response.data.highContrast;
		}
		else {
			valueHighContrast = this._getPropHighContrast(itemId);
		}

		const body = document.querySelector('body');
		const keyClass = 'high-contrast';
		const paramsURL = {highContrast: getParamUrl('highContrast')};

		if(valueHighContrast) body.classList.add(keyClass)
		else if(paramsURL.highContrast === "true") body.classList.add(keyClass)
		else body.classList.remove(keyClass);
	},

	_getPropHighContrast(itemId) {
		const storeItem = this._getStoreItem(itemId);

		return storeItem.highContrast;
	},

	_subscribeSetHighContrast(itemId) {
		PostMessageEventHandler.subscribe("SET_HIGH_CONTRAST", this._setHighContrast.bind(this, itemId));
	},

	_loadProcessInstanceData(itemId, processIds) {
		// const storeItem = this.store[itemId];
		let processInstanceData = {};

		LoadProcessInstanceDataActionHandler
			.execute(processIds)
			.then(response => {
				processInstanceData = response;

				document.title = `${processInstanceData.title} - ${processInstanceData.activityTitle}`;

				this._updateProcessInstanceData(itemId, processInstanceData);
			})
			.then(() => {
				this._publish(this.events.LOAD_PROCESS_INSTANCE_DATA_SUCCESS, processInstanceData);
			})
			// .then(this._loadFormDefinition.bind(this, itemId))
			.catch(this._handleLoadProcessInstanceDataError.bind(this, itemId));
	},

	_updateProcessInstanceData(itemId, processInstanceData) {
		return new Promise(resolve => {
			if(processInstanceData && processInstanceData.isBlocked) {
				this._handleBlockedProcessInstance(itemId, processInstanceData);
			}

			this.store[itemId].processInstanceData = processInstanceData;

			const status = processInstanceData.status || "";
			const isActivityInProgress = status === "" ? false : status == ActivityStatuses.IN_PROGRESS;
			const formAPI = FormAPI.form(this.store[itemId].formStoreId);
			formAPI.set({ readOnly: !isActivityInProgress });

			this.trigger({id: itemId, processInstanceData }, () => {
				ActivityFormEventsProxy.subscribeToFormSubmissionEvents(processInstanceData)
				resolve();
			})
		});
	},

	_handleBlockedProcessInstance(itemId, processInstanceData) {
		BlockedActivityInstanceHandler
			.execute(processInstanceData)
			.then(this.onDisplayFormResultMessages.bind(this, itemId))
			.then(this._publish.bind(this, this.events.LOAD_SUCCESS_BLOCKED_PROCESS, {
				entity: {
					content: {
						id: itemId || '',
						integrationId: {
							processInstanceId: processInstanceData ? processInstanceData.processInstanceId : 0,
							activityInstanceId: processInstanceData ? processInstanceData.activityInstanceId : 0,
							cycle: processInstanceData ? processInstanceData.cycle : 0
						}
					}
				}
			}))
	},

	_loadFormDefinition(itemId) {
		const storeItem = this.store[itemId];

		const formAPI = FormAPI.form(storeItem.formStoreId);
		return formAPI.loadDefinition();
	},

	_loadInitialValues(itemId) {
		const storeItem = this.store[itemId];
		const formAPI = FormAPI.form(storeItem.formStoreId);
		return formAPI.loadInitialValues();
	},

	_handleLoadProcessInstanceDataError(itemId, response) {
		this.trigger(Object.assign({
			id: itemId,
			displayFormResult: true,
			loadedWithErrors: true,
			displayFormHeader: false,
			formResultMessages:  [{
				messages: response.entity.errors.map(error => ({
					message: Realize.i18n.t(`form.errors.${error.code}`),
					type: 'error'
				}))
			}]
		}), this._publish.bind(this, this.events.LOAD_PROCESS_INSTANCE_DATA_ERROR, ...arguments));
	},

	_setFormLoadedWithErrors(itemId) {
		const storeItem = this.store[itemId];;
		const formAPI = new FormAPI({ storeId: storeItem.formStoreId });
		return formAPI.set({ formLoadedWithErrors: true }).apply();
	},

	/* markActivityAsRead functions */

	performMarkActivityAsReadRequest(itemId, read=true) {
		const processIds = serializePrivateProperties(this.store[itemId].processIds);
		const url = ProcessActionRoutes.MARK_AS_READ;
		const params = this.buildMarkActivityAsReadRequestParams(processIds, read);

		RestClient.post(url, params).then(
			this.handleMarkActivityAsReadSuccess.bind(this, read),
			ResponseHandler.displayErrorResponseFlashMessage.bind(this, 'flash-form')
		);
		ActivityFormEventHandler.publish(ActivityFormEvents.ACTIVITY_FORM_MARK_AS_READ, params);
	},

	handleMarkActivityAsReadSuccess(read) {
		if(!read) {
			ResponseHandler.displaySuccessActionFlashMessage('markActivityAsUnread');
		}
	},

	/* assignActivityToUser functions */

	handleAssignActivityToUserDataSuccess(itemId, response) {
		this.onDisplayFormResultMessages(itemId, [{
			messages: [
				{ message: Realize.i18n.t('successResponseMessages.assignActivityToUserTitle') },
				{ message: `${Realize.i18n.t('successResponseMessages.assignActivityToUser')} ${response.entity.name}` }
			]
		}]);
	},

	buildMarkActivityAsReadRequestParams(processIds, read) {
		return Object.assign({ read }, processIds);
	},

	buildAssignActivityToUserRequestParams(processIds, userId) {
		return Object.assign({ userId }, processIds);
	},

	/* handle window resize event */

	_initResizeEventListener(itemId) {
		this._setProperties(itemId, this.store[itemId], { layoutState: this._getLayoutState() });

		window.addEventListener("resize", this._handleOnResize.bind(this, itemId));
	},

	_getLayoutState() {
		if(window.innerWidth < ScreenSizes.SMALL_SCREEN_WIDTH)
			return ProcessLayoutStates.SMALL;
		else if (window.innerWidth > ScreenSizes.SMALL_SCREEN_WIDTH && window.innerWidth <= ScreenSizes.MEDIUM_SCREEN_WIDTH) {
			return ProcessLayoutStates.MEDIUM;
		} else {
			return ProcessLayoutStates.LARGE;
		}
	},

	_handleOnResize(itemId) {
		const storeItem = this._getStoreItem(itemId);
		const screenSize = this._getLayoutState();
		if (storeItem.layoutState != screenSize) {
			this._setProperties(itemId, this.store[itemId], { layoutState: screenSize })
		}
	},

	_resetStore() {
		this.store = {}
	}
}));

export default ProcessStore;
